import * as Yup from "yup";

export default Yup.object().shape({
  name: Yup.string()
    .required('Name is required.')
    .min(2, 'Name must be at least 2 characters.')
    .max(100, 'Name must not exceed 100 characters.'),
  language: Yup.string()
    .oneOf(['en', 'ar'], 'Language must be either English or Arabic.')
    .required('Language is required.'),
  description: Yup.string()
    .nullable()
    .max(1000, 'Description must not exceed 1000 characters.'),
});